import React, { useState, useLayoutEffect } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { signOut } from "next-auth/client";
import { useSession } from "next-auth/client";
import ErrorPage from "@/components/common/ErrorPage";
import api from "@/utils/api";
import getTenant from "@/utils/getTenant";
import { useRouter } from "next/router";
import UnauthorizedPage from "@/components/common/UnauthorizedPage";

export default function Custom404() {
  const [session] = useSession();
  const router = useRouter();
  const t = useTranslations();
  const [statusCode, setStatusCode] = useState(404);

  useLayoutEffect(() => {
    (async () => {
      if (!session) {
        router.push("/login");
      }
      if (session) {
        try {
          const response = await api({
            url: `/users/${session?.user?.id}`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${session.accessToken}`,
              "X-Tenant": getTenant(),
            },
          });
          if (response?.data?.data?.spam || response?.data?.data?.archived) {
            signOut({ callbackUrl: window.location.origin });
          }
        } catch (e) {
          setStatusCode(e?.response?.status || 404);
          if (e?.response?.status == 401) {
            signOut({ callbackUrl: window.location.origin });
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);
  if (!session || statusCode == 401) {
    return <UnauthorizedPage />;
  }
  return (
    <ErrorPage
      heading={t("errors.page.404.fourOFour")}
      message={t("errors.page.404.couldntFindIt")}
      description={t("errors.page.404.pageDoesntExist")}>
      <Link href="/">
        <a className="btn btn-success p-l-20 p-r-20">{t("common.goHome")}</a>
      </Link>
    </ErrorPage>
  );
}
